var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleIcon7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 54,
    viewBox: "0 0 51 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0566 28.7292C38.8694 28.7829 38.0843 28.8173 37.6182 28.6809C37.9141 29.936 38.444 30.1894 38.9898 30.2304C39.4759 30.2654 39.7646 30.0687 39.9919 29.5583C39.8175 28.9005 39.5677 28.6453 39.0566 28.7292Z",
    fill: "white",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9268 13.074C45.2148 13.3069 46.5518 14.297 47.0677 14.6216",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3833 18.3406C47.4179 18.7068 47.7832 20.2111 47.9023 20.6721",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6039 25.2239C46.4855 24.1626 46.5139 22.3287 46.5858 21.114",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0773 29.3464C40.4456 28.3332 40.9932 26.6164 40.0068 25.1929",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 25.0056C40.6443 25.031 40.6923 25.0611 40.744 25.0943C41.1372 25.3496 41.5729 25.6537 42.1916 25.5463C42.363 25.7098 42.4869 25.886 42.617 25.9687C42.6477 26.1165 42.7252 26.2508 42.8382 26.3518C42.7458 26.3947 42.4845 26.5823 42.3921 26.7555C41.7893 26.9969 41.0643 27.2057 40.541 27.4688",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6182 25.9712C42.7816 26.0557 43.2295 26.1669 43.5297 26.0198",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8394 26.354C42.8466 26.5314 43.252 27.9084 44.4717 28.0352",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3908 26.7578C42.0869 27.1489 42.1914 28.2858 42.7043 28.7263",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0566 28.7292C38.8694 28.7829 38.0843 28.8173 37.6182 28.6809C37.9141 29.936 38.444 30.1894 38.9898 30.2304C39.4759 30.2654 39.7646 30.0687 39.9919 29.5583C39.8175 28.9005 39.5677 28.6453 39.0566 28.7292Z",
    fill: "white",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6787 24.8879C32.9163 25.0424 33.1801 25.2258 33.3764 25.5698C34.2551 26.814 35.6887 27.2738 36.6033 27.2593C37.126 27.6817 37.5015 28.2301 37.6091 28.6471C37.6091 28.6586 37.6152 28.6688 37.6176 28.6803C38.0831 28.8166 38.8689 28.7823 39.0561 28.7286C39.5672 28.6447 39.8169 28.8999 39.9914 29.5576C40.0211 29.4918 40.0521 29.4225 40.077 29.3458C40.4453 28.3327 40.9929 26.6161 40.0066 25.1927",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8345 27.2593C37.1079 27.2593 38.1107 26.6709 38.358 26.4561",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7334 27.3924C37.9475 27.4172 38.1639 27.3709 38.349 27.2605",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1662 1C24.7882 3.84698 26.894 4.60369 28.0486 5.49495C29.5005 6.49544 31.0836 7.59489 31.6676 8.32504C32.2516 9.05519 33.8614 10.1323 35.8262 10.1353C37.7909 10.1383 39.9781 9.74491 42.3755 10.6585C44.1531 11.3349 45.978 12.1254 46.4278 12.4048C47.1199 12.7838 47.6626 13.7022 47.0701 14.6218C48.0783 15.1885 49.0148 15.8842 49.5004 16.4418C50.1944 17.178 50.2223 17.858 49.4469 18.8326C49.0476 19.334 48.1834 20.2265 47.9021 20.6736C48.1063 21.6771 48.3159 22.2142 48.4417 22.773C48.6441 23.4192 48.6575 24.3799 46.6034 25.2247C46.7225 26.2499 47.0251 27.426 45.5259 28.2533C43.1984 29.4336 41.3473 30.1529 40.0771 29.3479C40.0522 29.4246 40.0212 29.494 39.9915 29.5597C39.817 28.902 39.5673 28.6468 39.0562 28.7306C38.869 28.7843 38.0832 28.8187 37.6177 28.6824C37.6153 28.6709 37.6092 28.6606 37.6092 28.6492C37.5016 28.2322 37.1261 27.6837 36.6034 27.2613C35.6888 27.2758 34.2552 26.816 33.3765 25.5717C33.1802 25.2277 32.9164 25.0461 32.6788 24.8898C32.4412 24.7335 31.368 23.5025 30.8393 22.7778C30.3105 22.0531 28.5202 19.926 26.5755 18.5984C24.6175 17.359 22.9183 16.0007 21.4422 14.961C19.966 13.9213 10.3033 9.97059 5.34863 8.63822",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24316 41.0789C2.92167 41.8634 3.28023 41.73 4.77399 42.535C6.26775 43.34 7.73903 45.1684 9.25954 46.6733C9.93957 47.3124 10.5394 48.0992 10.9429 48.5886C11.6722 49.5445 13.0407 50.8877 14.0453 51.6251C14.5533 51.9419 15.1124 52.4754 16.1237 52.52C16.4275 52.5097 16.7606 52.5031 16.8924 52.5381C17.0243 52.5731 17.5755 52.5544 17.8356 52.5254C18.0804 52.5027 18.3265 52.4959 18.5722 52.5049C19.7487 52.5737 20.2616 52.4518 21.1063 52.3577C21.7858 52.2744 22.0179 52.1217 22.1911 51.9564C22.4682 51.7024 23.0273 51.1931 23.2242 51.0368C23.615 50.7242 24.075 50.6669 24.3181 50.6331C24.9781 50.5854 25.9729 50.3018 26.3947 50.1461C27.6527 49.7364 27.5876 49.7883 28.0537 49.2241C30.1619 49.425 30.5083 48.3189 30.7046 47.9345C30.9009 47.5501 31.4047 46.4139 31.6909 45.7471C32.0865 44.8419 31.8684 44.1118 31.7638 43.7557C31.7146 43.55 31.5888 43.0636 31.4071 42.4282C31.6867 42.2695 32.2415 41.8676 32.5308 41.5085C32.6033 41.4102 32.6662 41.3051 32.7186 41.1948C31.9808 41.2708 31.4497 41.1742 31.1871 41.1567C30.944 41.1314 30.9094 41.1145 30.8511 40.9986C30.608 40.5539 30.436 40.0295 30.4998 39.7079C30.1844 39.5444 29.0194 39.5269 28.2512 39.5027C27.0936 39.4267 25.6861 38.4612 24.4457 37.7142C23.2054 36.9671 22.605 37.0214 22.227 36.99C21.849 36.9587 21.0036 36.9659 19.6296 36.465C18.2555 35.9642 17.1307 36.1271 16.7004 36.0342C16.2701 35.9413 13.7998 35.4525 13.2796 35.4205C12.7594 35.3885 11.1216 35.0132 9.92681 34.6137C8.73204 34.2142 6.16444 33.685 5.31182 33.4587",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6344 29.8208L47.2989 30.4484L40.6019 45.127L32.4111 41.1666",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0664 25.4128L45.967 25.685L39.8011 39.4502L24.9023 37.8342",
    fill: "#5545A3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0664 25.4128L45.967 25.685L39.8011 39.4502L24.9023 37.8342",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6602 37.6282L33.2855 25.3013",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5225 38.4438L39.9214 42.2322L44.9594 31.5339L43.3975 31.0759",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleIcon7);
export default __webpack_public_path__ + "static/media/purple-icon-7.4776d60d70371ffdeef4e61942a3832b.svg";
export { ForwardRef as ReactComponent };